export const ServiceHost = "http://192.168.31.46:808/api"
// export const ServiceHost = "https://service.amznau.com/api"